import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Layout } from "../components/Layout";
import { BiniBubble } from "../components/Bini";
import { SongCard } from "../components/SongCard";
import { FlagAll, FlagFR, FlagEN } from "../components/Flags";
import { HiddenStar } from "../components/HiddenStar";
import { t } from "../i18n";

const LANGS = [
  { v: "", label: "songs.allLangs", Flag: FlagAll, id: "lang-filter-all" },
  { v: "fr", label: "lang.fr", Flag: FlagFR, id: "lang-filter-fr" },
  { v: "en", label: "lang.en", Flag: FlagEN, id: "lang-filter-en" },
];

const Chip = ({ active, color = "#38B6FF", onClick, testId, children }) => (
  <button type="button" onClick={onClick} data-testid={testId} aria-pressed={active}
    className={`btn-3d !min-h-[56px] !text-lg !px-5 shrink-0 ${active ? "" : "is-off"}`} style={{ "--c": color }}>
    {children}
  </button>
);

export default function Songs() {
  const [themes, setThemes] = useState([]);
  const [songs, setSongs] = useState(null);
  const [theme, setTheme] = useState("");
  const [lang, setLang] = useState("");

  useEffect(() => {
    Promise.all([api.get("/themes"), api.get("/songs")]).then(([th, so]) => {
      const used = new Set(so.data.map((s) => s.theme));
      setThemes(th.data.filter((x) => used.has(x.slug)));
    });
  }, []);
  useEffect(() => {
    const params = {};
    if (theme) params.theme = theme;
    if (lang) params.language = lang;
    api.get("/songs", { params }).then((r) => setSongs(r.data));
  }, [theme, lang]);

  return (
    <Layout back="/">
      <div className="relative"><HiddenStar id="songs-title" className="right-0 -top-2 sm:right-1/3" /></div>
      <h1 className="text-4xl sm:text-5xl font-extrabold text-white drop-shadow-[0_3px_0_rgba(30,42,90,0.35)]">{t("songs.title")}</h1>

      <div className="mt-6 flex gap-3 overflow-x-auto no-scrollbar py-2 -mx-4 px-4" role="group" aria-label="Langue">
        {LANGS.map(({ v, label, Flag, id }) => (
          <Chip key={id} active={lang === v} onClick={() => setLang(v)} testId={id} color="#8A3FE0">
            <Flag /> {t(label)}
          </Chip>
        ))}
      </div>
      <div className="mt-2 flex gap-3 overflow-x-auto no-scrollbar py-2 -mx-4 px-4" role="group" aria-label="Thème">
        <Chip active={!theme} onClick={() => setTheme("")} testId="theme-filter-all" color="#FF8A1F">{t("songs.allThemes")}</Chip>
        {themes.map((th) => (
          <Chip key={th.slug} active={theme === th.slug} onClick={() => setTheme(th.slug)} testId={`theme-filter-${th.slug}`} color={th.color}>
            {th.name}
          </Chip>
        ))}
      </div>

      {songs && songs.length === 0 && (
        <BiniBubble testId="songs-empty-state" className="mt-10">{t("songs.empty")}</BiniBubble>
      )}
      <div data-testid="songs-grid" className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {songs?.map((s, i) => <SongCard key={s.id} song={s} index={i} />)}
      </div>
      <div className="relative h-16"><HiddenStar id="songs-bottom" className="left-2 top-2" /></div>
    </Layout>
  );
}
